import React from 'react'

import { isChunkLoadError } from '../../../utils/lazyWithReload.js'

// User-visible fallback for render-time errors. Class component because
// React still requires class form for getDerivedStateFromError /
// componentDidCatch. Detects chunk-load failures that slipped past
// lazyWithReload (e.g. a second failure after the one-shot reload
// already fired) and shows a "we've updated the app — reload" panel;
// any other render error gets a generic "something went wrong" with
// the same Reload button.
export default class ErrorBoundary extends React.Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // Surface to console for debugging; swap for the real error
    // reporter (Sentry / Datadog / etc.) when one is wired up.
    console.error('[ErrorBoundary]', error, info)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    const isChunkErr = isChunkLoadError(error)
    return (
      <div
        role="alert"
        style={{
          maxWidth: 420,
          margin: '64px auto',
          padding: 24,
          textAlign: 'center',
          fontFamily: 'inherit',
        }}
      >
        <h2 style={{ marginBottom: 8 }}>
          {isChunkErr ? "We've updated the app" : 'Something went wrong'}
        </h2>
        <p style={{ marginBottom: 16, opacity: 0.8 }}>
          {isChunkErr
            ? 'Reload the page to load the latest version.'
            : 'Please reload and try again.'}
        </p>
        <button
          type="button"
          onClick={this.handleReload}
          style={{
            padding: '8px 16px',
            borderRadius: 6,
            border: '1px solid currentColor',
            background: 'transparent',
            cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    )
  }
}
